/**
 * @license Siftrock
 * (c) 2014-2018 Siftrock, Inc. http://siftrock.com
 * Unauthorized copying of this file, via any medium is strictly prohibited
 */

import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';


@Injectable()
export class AccountService {

  constructor(private http: HttpClient) { }

  getAccount(): Observable<any> {
    return this.http
      .get(
        `/api/v1/account`
      );
  }

  getAccountSubscription(): Observable<any> {
    return this.http
      .get(
        `/api/v1/account/subscription`
      );
  }

  updateAccount(update: any): Observable<any> {
    return this.http
      .put(
        `/api/v1/account`,
        update
      );
  }

  updateAccountSubscription(update: any): Observable<any> {
    return this.http
      .put(
        `/api/v1/account/subscription`,
        update
      );
  }

  addReplyDomain(domain: string): Observable<any> {
    return this.http
      .post(
        `/api/v1/account/domain`,
        { domain: domain }
      );
  }

  removeReplyDomain(domain: string): Observable<any> {
    return this.http
      .delete(
        `/api/v1/account/domain/${domain}`
      );
  }

  testMX(domain: string): Observable<any> {
    return this.http
      .get(
        `/api/v1/dns/mx/${domain}`
      );
  }

  getIntegrations(): Observable<any> {
    return this.http
      .get(
        `/api/v1/account/integrations`
      );
  }

  getApiTokens(): Observable<any> {
    return this.http
      .get(
        `/api/v1/account/apitokens`
      );
  }

  removeIntegration(partner: string): Observable<any> {
    return this.http
      .delete(
        `/api/v1/account/integration/${partner}`
      );
  }

  addIgnoreDomain(domain: string): Observable<any> {
    return this.http
      .post(
        `/api/v1/account/ignoredomain`,
        { domain: domain }
      );
  }

  removeIgnoreDomain(domain: string): Observable<any> {
    return this.http
      .delete(
        `/api/v1/account/ignoredomain/${domain}`
      );
  }

  getUsers(): Observable<any> {
    return this.http
      .get(
        `/api/v1/account/users`
      );
  }

  getAccounts(): Observable<any> {
    return this.http
      .get(
        `/api/v1/account/multi/access`
      );
  }

  getInboxes(): Observable<any> {
    return this.http
      .get(
        `/api/v1/account/inbox`
      );
  }

  inviteInbox(model): Observable<any> {
    return this.http
      .post(
        `/api/v1/account/inviteinbox`,
        model
      );
  }

  deleteInbox(inboxId): Observable<any> {
    return this.http
      .delete(
        `/api/v1/account/inbox/${inboxId}`
      );
  }

  renameInbox(inboxId: string, name: string) {
    let model = {
      id: inboxId,
      name: name
    };
    return this.http
      .post(
        `/api/v1/account/renameinbox`,
        model
      );
  }

  inviteExistingInbox(inboxId): Observable<any> {
    return this.http
      .get(
        `/api/v1/account/inviteinbox/${inboxId}`
      );
  }

  getBots(): Observable<any> {
    return this.http
      .get(
        `/api/v1/account/bot`
      );
  }
}



// WEBPACK FOOTER //
// ./client/app/services/account.service.ts